<template>
  <div id="app">
      <router-view/>
  </div>
</template>
<script>
export default {};
</script>

<style>
.body {
  margin: 0;
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

p,h1,h2,h3,h4,h5,h6,thead,tbody,tr,td {
  margin: 0;
  padding: 0
}
</style>
